<template>
  <fieldset class="fieldset">
    <div
      v-for="(group, index) in groups"
      :key="index"
      class="checkbox"
      :class="[ isMini && 'checkbox--mini']"
    >
      <input
        :id="`${id}-${index}`"
        :type="type"
        class="checkbox__control"

        :disabled="group.isDisabled"
        :value="group.value || group"
        :checked="is_checkedByGroup(group)"
        @change="event_changeByGroup(group,$event)"
      >
      <label
        class="checkbox__label"
        :for="`${id}-${index}`"
      >
        <v-icon
          class="checkbox__check"
          type="check"
        />
        {{ group.value || group }}
      </label>
      <div
        v-if="group.items"
        class="ml-3 mt-2"
      >
        <div
          v-for="(item,itemIndex) in group.items"
          :key="itemIndex"
          class="checkbox checkbox--mini"
        >
          <input
            :id="`${group.id}-${itemIndex}`"
            :type="type"
            class="checkbox__control"
            :value="item"
            :checked="is_checkedByItem(group,item)"
            @change="event_changeByItem(group,item,$event)"
          >
          <label
            class="checkbox__label"
            :for="`${group.id}-${itemIndex}`"
          >
            <v-icon
              class="checkbox__check"
              type="check"
            />
            {{ item.value }}
          </label>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
  import Icon from '@/atoms/Icon';

  export default {
    name: 'CheckboxList',
    components: {
      'v-icon': Icon
    },
    model: {
      prop: 'selected',
      event: 'change'
    },
    props: {
      type: {
        type: String,
        default: 'checkbox'
      },
      id: {
        type: [String, Number],
        default: null,
      },
      groups: {
        type: Array,
        default: null,
      },
      pattern: {
        type: String,
        default: null
      },
      isRequired: {
        type: Boolean,
        default: false
      },
      isMini: {
        type: Boolean,
        default: false
      },
      selectedGroup:{
        type: Array,
        default: () => []
      }
    },
    data: () => ({
      selected: [],
    }),
    mounted(){
      this.selected = this.selectedGroup;
    },
    methods: {
      event_changeByGroup(group, event) {
        let groupIndex = this.findIndex(group, this.selected);
        if (event.target.checked) {
          this.selected.push({id: group.id, value: group.value, items: []})
          let g_i = this.findIndex(group, this.selected);
          if(group.items) {
            group.items.forEach((item) => {
              this.selected[g_i].items.push({id: item.id, value: item.value})
            })
          }
        } else {
          this.selected.splice(groupIndex, 1)
        }
        this.$emit('change', this.selected)
      },
      is_checkedByGroup(group) {
        return this.findIndex(group, this.selected) !== -1;
      },
      event_changeByItem(group, item, event) {
        let groupIndex = this.findIndex(group, this.selected);
        if (event.target.checked) {
          if (groupIndex === -1) {
            this.selected.push({id: group.id, value: group.value, items: []});
            let g_i = this.findIndex(group, this.selected);
            this.selected[g_i].items.push({id: item.id, value: item.value});
          } else {
            this.selected[groupIndex].items.push(item);
          }
        } else {
          let itemIndex = this.findIndex(item, this.selected[groupIndex].items);
          this.selected[groupIndex].items.splice(itemIndex, 1);
          if (this.selected[groupIndex].items.length === 0) {
            this.selected.splice(groupIndex, 1)
          }
        }
        this.$emit('change', this.selected)
      },
      is_checkedByItem(group, item) {
        let groupIndex = this.findIndex(group, this.selected);
        if (groupIndex !== -1) {
          return this.findIndex(item, this.selected[groupIndex].items) !== -1;
        } else
          return false;
      },
      findIndex(obj, list) {
        return list.findIndex(i => i.id == obj.id);
      }
    }

  };
</script>
